import React from 'react';

// 置於最內部，接收click事件最優先
// 上層元件的position要設為relative
// 傳入href

// 用雙class是為了提高專用css優先權，避免被其他css影響
const MaskLink = props => (
  <a 
    style={{outline: 'none'}}
    className='component a-mask-link'
    href={props.href}
    target="_blank"
    onClick={e => {e.stopPropagation();}}>
  </a>
);

export default MaskLink;


// WEBPACK FOOTER //
// ./src/commonComponents/MaskLink.jsx